import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import classes from './ConfirmDialog.module.css';

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDialog = ({ open, title = "Confirmación", message, onConfirm, onClose }: ConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} className={classes['btn-newsan-cancel']}>Cancelar</Button>
        <Button onClick={onConfirm} className={classes['button-newsan-red']}>Aceptar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;